import About from "../about";
import Tabs from '../tabs'

const RightSideComponent = () => {
  return (
    <>
      <About />
      <Tabs />
    </>
  );
};

export default RightSideComponent;
